import { call, put } from 'redux-saga/effects';
import { photoCaptureDataFailureAction, getPhotoCaptureIntelligentReactivationUrlDataSuccessAction } from '../actions';
import { PhotoCaptureIntelligentReactivationUrlService } from '../services';
import { getErrorMessagesBasedOnStatusCode } from '../utilities';
export function* photoCaptureGetIntelligentReactivationUrlDetailsSaga(action, photoCaptureIntelligentReactivationUrlService = new PhotoCaptureIntelligentReactivationUrlService()) {
    const { coCode, contextId } = action.payload;
    try {
        yield call({
            context: photoCaptureIntelligentReactivationUrlService,
            fn: photoCaptureIntelligentReactivationUrlService.photoCaptureGetIntelligentReactivationUrlData
        }, coCode, contextId);
        yield put(getPhotoCaptureIntelligentReactivationUrlDataSuccessAction());
    }
    catch (error) {
        const errorMessage = getErrorMessagesBasedOnStatusCode(error);
        yield put(photoCaptureDataFailureAction(errorMessage));
    }
}
//# sourceMappingURL=intelligentPhotoCaptureRectivationUrlDetailsSaga.js.map